import escButton from '../../assets/museu/esc.png';
import './leave.css';
import { useKeyPressedOnce } from '../../hooks/useKeyPressedOnce';

interface LeaveButtonProps {
  onUnsee(): void;
}

const LeaveButton: React.VFC<LeaveButtonProps> = ({ onUnsee }) => {
  useKeyPressedOnce('Escape', onUnsee)

  return (
    <button className="leave-button" onClick={onUnsee}>
      <img alt='leave' src={escButton} />
    </button>
  );
}

export default LeaveButton;
